import { useState } from 'react'

export const useRemoveContract = () => {
  const [isRemoving, setIsRemoving] = useState(false)

  const removeContract = async (contractId: string) => {
    setIsRemoving(true)

    await window.hapi.contract.service.removeContract.run(contractId)

    setIsRemoving(false)
  }

  return {
    removeContract,
    isRemoving,
  }
}
